export default {
  state: {
    preview: {
      title: '',
      tnc: {
        text: '',
        img: ''
      },
      tcp: {
        text: '',
        img: ''
      }
    }
  },
  mutations: {
    setPreview (state, data) {
      state.preview.title = data.title
      state.preview.tnc = data.tnc
      state.preview.tcp = data.tcp
    }
  },
  sharedMutations: [
    'geofences/setPreview'
  ]
}
  


// WEBPACK FOOTER //
// ./src/store/geofences/arrival-instruction.js